import React, { useEffect } from 'react';
import { ProgramsNavigation } from './programs/ProgramsNavigation';
import { ProgramsHeader } from './programs/ProgramsHeader';
import { ProgramsGrid } from './programs/ProgramsGrid';
import { ProgramsCurriculum } from './programs/ProgramsCurriculum';
import { ProgramsCTA } from './programs/ProgramsCTA';
import { ProgramsFooter } from './programs/ProgramsFooter';
export function ProgramsPage() {
  useEffect(() => {
    document.title = "Programs | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-1746">
      <ProgramsNavigation data-id="element-1747" />
      <ProgramsHeader data-id="element-1748" />
      <ProgramsGrid data-id="element-1749" />
      <ProgramsCurriculum data-id="element-1750" />
      <ProgramsCTA data-id="element-1751" />
      <ProgramsFooter data-id="element-1752" />
    </div>;
}